<!--
 * @Author: WLL
 * @Date: 2020-04-14 12:08:16
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-09 16:06:43
 * @Description: 分析师预测排行
 -->
<template>
  <div class="analyst">
    <div class="analyst_above">
      <FilterItem label="报告发布时间" :spacing="10">
        <SjAutoComplete
          v-model="timeRangeSelected"
          :options="timeRangeStartThreeList"
          style="width: 170px;"
          @change="search"
          @click.native="onFilterClick('报告发布时间')"
        ></SjAutoComplete>
      </FilterItem>
      <FilterItem label="行业" style="margin-left: 30px;">
        <SelectIndustry
          v-model="industrySelected"
          @secondChange="onSecondChanged"
          @click.native="onFilterClick('行业')"
          :type.sync="industryType"
          @change="search"
        ></SelectIndustry>
      </FilterItem>
    </div>
    <div class="analyst_below horizontal_container">
      <SjCard
        class="horizontal_item"
        style="padding: 0 5px;"
        v-sj-loading="analystLoading"
      >
        <DisplayArea
          title="分析师预测排行"
          :showMore="false"
          icon-class="icon_xh iconicon_ranking"
          icon-size="14px"
          icon-color="#f3a709"
        >
          <common-table
            icon-class="icon_xh iconicon_ranking"
            icon-size="14px"
            icon-color="#FF5C47"
            default-selected="AVGDESC"
            ref="analystTable"
            :data="analystData"
            @order="onAnalystTableOrder"
            :columns="analystColumns"
            :tableProps="analystProps"
            :scrollDisabled="
              analystTotalPage !== 0 && analystTotalPage < analystPageNo
            "
            @infiniteScroll="getMoreAnalystData"
            @current-change="onCurrentChange"
          ></common-table>
        </DisplayArea>
      </SjCard>
      <SjCard class="horizontal_item">
        <div v-if="analystSelected" class="analyst_container">
          <div class="analyst_report" v-sj-loading="analystReportLoading">
            <DisplayArea title="最新研报" icon-size="14px" :showMore="false">
              <common-table
                :data="analystReportData"
                :columns="analystReportColumns"
                :tableProps="analystReportProps"
                :scrollDisabled="
                  analystReportTotalPage !== 0 &&
                    analystReportTotalPage < analystReportPageNo
                "
                @infiniteScroll="getMoreAnalystReportData"
                @cell-click="onReportClickWrapper"
              ></common-table>
            </DisplayArea>
          </div>
          <div class="analyst_chart" v-sj-loading="analystChartLoading">
            <DisplayArea
              :title="analystSelected.RESEARCHER"
              :showSplitline="false"
              icon-size="18px"
              icon-color="#399BFF"
              icon-class="icon_xh iconicon_personage"
              :showMore="false"
            >
              <template v-slot:titleLeft>
                <span class="analyst_chart_info">
                  {{ analystSelected.COMPANYNAME || "-" }}
                </span>
              </template>
              <template v-slot:titleRight>
                <span class="analyst_chart_info">
                  {{ analystChartLabel }}
                  <span class="analyst_chart_info_value">{{
                    analystChartLastValue
                  }}</span>
                </span>
              </template>
              <Chart
                v-if="analystChartData && analystChartData.length"
                :options="analystChartOptions"
              ></Chart>
              <SjBlank v-else />
            </DisplayArea>
          </div>
          <div class="analyst_stock" v-sj-loading="analystStockLoading">
            <DisplayArea
              title="最新追踪推荐股票"
              icon-size="14px"
              :showMore="false"
            >
              <common-table
                :data="analystStockData"
                :columns="analystStockColumns"
                :tableProps="analystStockProps"
                :scrollDisabled="
                  analystStockTotalPage !== 0 &&
                    analystStockTotalPage < analystStockPageNo
                "
                @cell-click="onAnalystStockClick"
                @infiniteScroll="getMoreAnalystStockData"
              ></common-table>
            </DisplayArea>
          </div>
        </div>
        <SjBlank v-else />
      </SjCard>
    </div>
  </div>
</template>

<script>
import FilterItem from "@/components/FilterItem.vue";
import DisplayArea from "@/components/DisplayArea.vue";
import Chart from "@/components/Chart";
import SelectIndustry from "@/components/SelectIndustry";
import { timeRangeStartThreeList } from "@/utils/const";
import { dateSort, tooltipFormatter, publishChartDateFormatter } from "@/utils";
import reportMixin from "@/views/mixins/reportMixin";
import isequal from "lodash.isequal";
import CommonTable from "@/components/CommonTable/index";

export default {
  mixins: [reportMixin],
  components: {
    CommonTable,
    FilterItem,
    DisplayArea,
    Chart,
    SelectIndustry
  },
  data() {
    return {
      analystOrder: "AVGDESC",
      timeRangeSelected: 3,
      timeRangeStartThreeList,

      industrySelected: [],
      industryType: "011",

      analystPageNo: 1,
      analystPageSize: 40,
      analystTotalPage: 0,
      analystData: [],
      analystColumns: [
        {
          label: "排名",
          minWidth: 45,
          center: true,
          align: "center",
          customRender: this.rankRender
        },
        {
          prop: "RESEARCHER",
          label: "分析师",
          center: true,
          minWidth: 70,
          customRender: this.analystRender
        },
        {
          prop: "COMPANYNAME",
          label: "机构",
          center: true,
          minWidth: 75,
          customRender: this.agencyRender
        },
        {
          prop: "AVG_RATE",
          order: {
            asc: "AVGASC",
            desc: "AVGDESC"
          },
          label: "平均收益率",
          center: true,
          helpText: "根据研报推荐个股计算所得",
          align: "right",
          customRender: this.renderIncome
        },
        {
          prop: "RPT_SUM",
          center: true,
          label: "发表研报数量",
          width: 100,
          align: "right"
        }
      ],
      analystProps: {
        "highlight-current-row": true,
        defaultSelection: 0
      },
      analystSelected: null,
      analystLoading: false,

      analystReportPageNo: 1,
      analystReportPageSize: 40,
      analystReportTotalPage: 0,
      analystReportData: [],
      analystReportColumns: [
        {
          prop: "PUBLISHDATE",
          label: "日期",
          width: 80,
          center: true,
          formatter: this.publishDateFormatter
        },
        {
          prop: "SECURITYNAME",
          label: "股票",
          center: true,
          width: 70,
          customRender: this.stockRender
        },
        {
          prop: "PUBLISHNAME",
          label: "行业",
          width: 80,
          center: true,
          customRender: this.ellipsisRender
        },
        {
          prop: "REPORTTITLE",
          label: "标题",
          customRender: this.ellipsisPointerRender
        },
        {
          prop: "COMPANYNAME",
          label: "机构",
          width: 70,
          center: true,
          customRender: this.agencyRender
        },
        {
          prop: "ALLRESEARCHER",
          label: "作者",
          width: 70,
          center: true,
          customRender: this.researcherRender
        },
        {
          prop: "EMRATINGNAME",
          label: "评级",
          width: 40,
          center: true,
          customRender: this.ratingRender
        },
        {
          prop: "ATTACHNAME",
          label: "附件",
          width: 40,
          align: "center",
          center: true,
          customRender: this.pdfIconRender
        }
      ],
      analystReportProps: {},
      analystReportLoading: false,

      analystChartData: [],
      analystChartLoading: false,

      analystStockPageNo: 1,
      analystStockPageSize: 40,
      analystStockTotalPage: 0,
      analystStockData: [],
      analystStockColumns: [
        {
          prop: "SECURITYCODE",
          label: "代码",
          center: true,
          minWidth: 70
        },
        {
          prop: "SECURITYNAME",
          label: "名称",
          center: true,
          minWidth: 80,
          customRender: this.stockRender
        },
        {
          prop: "PUBLISHDATE",
          center: true,
          label: "评级日期",
          minWidth: 110,
          formatter: this.publishDateFormatter
        },
        {
          prop: "EMRATINGNAME",
          center: true,
          label: "当前评级",
          minWidth: 80,
          customRender: this.ratingRender
        },
        {
          prop: "BEGIN_NEW",
          label: "成交价格",
          center: true,
          minWidth: 80,
          align: "right"
        },
        {
          prop: "END_NEW",
          label: "最新价格",
          center: true,
          minWidth: 80,
          align: "right"
        },
        {
          prop: "RATE",
          center: true,
          label: "收益率",
          minWidth: 70,
          helpText: "根据研报推荐个股计算所得",
          align: "right",
          customRender: this.renderIncome
        }
      ],
      analystStockProps: {},
      analystStockLoading: false,
      throttlingCount: 0
    };
  },
  computed: {
    analystChartLabel() {
      const { analystChartData } = this;
      let lastDate = "-";
      if (analystChartData.length) {
        lastDate = analystChartData[analystChartData.length - 1].DATE;
      }
      return `推荐股票30日内复权收益率（${lastDate}）`;
    },
    analystChartLastValue() {
      const { analystChartData } = this;
      let lastValue = "-";
      if (analystChartData.length) {
        lastValue = `${
          analystChartData[analystChartData.length - 1].AVG_RATE
        }%`;
      }
      return lastValue;
    },
    analystChartOptions() {
      const { analystChartData } = this;
      return {
        grid: {
          left: 30
        },
        tooltip: {
          formatter: params => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.throttlingCount++;
            if (this.throttlingCount % 50 === 0) {
              window.sendEvent("view_chart", {
                chart_name: "分析师推荐股票平均收益率折线图",
                upstream_page_title: "首页"
              });
            }
            const data = params[0];
            return `${data.axisValueLabel}<br/>${data.marker}${data.seriesName}：${data.value}%`;
          }
        },
        xAxis: {
          splitLine: {
            show: true
          },
          data: analystChartData.map(v => v.DATE)
        },
        series: [
          {
            name: "复权收益率",
            type: "line",
            showSymbol: false,
            lineStyle: {
              color: "#dd021b",
              width: 1
            },
            data: analystChartData.map(v => v.AVG_RATE)
          }
        ]
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    onAnalystStockClick(data) {
      this.onStockClick(null, data);
    },
    onAnalystTableOrder(order) {
      this.analystOrder = order;
      this.getAnalystList();
    },
    init() {
      this.search();
    },
    onExpandChanged(key, value, name) {
      this.onFilterClick("行业", name);
    },
    onSecondChanged(label) {
      this.onFilterClick("行业", label);
    },
    onFilterClick(first_screening, second_screening = "") {
      window.sendEvent("click_filter", {
        page_type: "分析师预测",
        first_screening: first_screening,
        second_screening: second_screening
      });
    },
    onReportClickWrapper(params, column) {
      const property = column.property;
      if(["REPORTTITLE"].includes(property)){
        this.onReportClick(params, {
          upstream_page_type: "分析师预测排行",
          upstream_page_modular: "最新研报"
        });
      }
    },
    search() {
      this.analystSelected = null;
      this.getAnalystList();
    },
    async getAnalystList() {
      this.analystPageNo = 1;
      this.analystTotalPage = 0;
      this.analystData = [];
      this.getMoreAnalystData(true);
    },
    async getMoreAnalystData(init = false) {
      try {
        this.analystLoading = true;
        const params = {
          pageNo: this.analystPageNo,
          pageSize: this.analystPageSize,
          V_MONTH: this.timeRangeSelected,
          V_INDUCODE: `${this.industryType}`,
          order: this.analystOrder
        };
        const { industrySelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        }
        const { data, page } = await this.$apis.Analyst.getAnalystList(params);
        this.analystPageNo += 1;
        this.analystTotalPage = page.totalPage;
        if (init) {
          this.analystData = data;
          if (data.length) {
            if (
              this.$refs.analystTable &&
              this.$refs.analystTable.$refs.table
            ) {
              this.$refs.analystTable.$refs.table.selection = 0;
              this.onCurrentChange(data[0], false);
            }
          } else {
            this.analystSelected = null;
          }
        } else {
          data.forEach(v => {
            this.analystData.push(v);
          });
        }
      } finally {
        this.analystLoading = false;
      }
    },
    onCurrentChange(val, sendEvent = true) {
      if (!val) {
        return;
      }
      if (!isequal(this.analystSelected, val)) {
        this.analystSelected = val;
        this.getAnalystReportData();
        this.getAnalystChartData();
        this.getAnalystStockData();
      }
      if (sendEvent) {
        window.sendEvent("click_analyst", {
          page_type: "分析师预测",
          analyst_id: val.RESEARCHERCODE,
          analyst_name: val.RESEARCHER
        });
      }
    },
    async getAnalystReportData() {
      this.analystReportPageNo = 1;
      this.analystReportTotalPage = 0;
      this.analystReportData = [];
      this.getMoreAnalystReportData(true);
    },
    async getMoreAnalystReportData(init = false) {
      try {
        this.analystReportLoading = true;
        const { analystSelected } = this;
        const params = {
          pageNo: this.analystReportPageNo,
          pageSize: this.analystReportPageSize,
          V_ANALYST: analystSelected.RESEARCHERCODE,
          V_MONTH: this.timeRangeSelected,
          V_COMPANYCODE: analystSelected.COMPANYCODE,
          V_INDUCODE: `${this.industryType}%`
        };
        const { industrySelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        }
        const { data, page } = await this.$apis.Analyst.getAnalystReport(
          params
        );
        this.analystReportPageNo += 1;
        this.analystReportTotalPage = page.totalPage;
        if (init) {
          this.analystReportData = data;
        } else {
          data.forEach(v => {
            this.analystReportData.push(v);
          });
        }
      } finally {
        this.analystReportLoading = false;
      }
    },
    async getAnalystChartData() {
      try {
        this.analystChartLoading = true;
        this.analystChartData = [];
        const { analystSelected } = this;
        const params = {
          V_ANALYST: analystSelected.RESEARCHERCODE,
          V_COMPANYCODE: analystSelected.COMPANYCODE,
          // V_MONTH: this.timeRangeSelected,
          V_MONTH: 3,
          V_INDUCODE: `${this.industryType}`
        };
        const { industrySelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        }
        const { data } = await this.$apis.Analyst.getRateLineData(params);
        data.sort((a, b) => dateSort(a.DATE, b.DATE));
        this.analystChartData = data.map(v =>
          Object.assign(v, {
            DATE: publishChartDateFormatter(v.DATE)
          })
        );
      } finally {
        this.analystChartLoading = false;
      }
    },
    async getAnalystStockData() {
      this.analystStockPageNo = 1;
      this.analystStockTotalPage = 0;
      this.analystStockData = [];
      this.getMoreAnalystStockData(true);
    },
    async getMoreAnalystStockData(init = false) {
      try {
        this.analystStockLoading = true;
        const { analystSelected } = this;
        const params = {
          pageNo: this.analystStockPageNo,
          pageSize: this.analystStockPageSize,
          V_ANALYST: analystSelected.RESEARCHERCODE,
          V_COMPANYCODE: analystSelected.COMPANYCODE,
          V_MONTH: this.timeRangeSelected,
          V_INDUCODE: `${this.industryType}%`
        };
        const { industrySelected } = this;
        if (Array.isArray(industrySelected) && industrySelected.length) {
          Object.assign(params, {
            V_INDUCODE: industrySelected[0]
          });
        }
        const { data, page } = await this.$apis.Analyst.getAnalystStock(params);
        this.analystStockPageNo += 1;
        this.analystStockTotalPage = page.totalPage;
        if (init) {
          this.analystStockData = data;
        } else {
          data.forEach(v => {
            this.analystStockData.push(v);
          });
        }
      } finally {
        this.analystStockLoading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.analyst {
  display: flex;
  flex-direction: column;
  .analyst_above {
    border-bottom: 1px solid @color-splitline-xh;
    padding: 12px 17px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .analyst_below {
    flex: 1;
    min-height: 0;
    margin: 10px;

    .analyst_container {
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: auto;

      .analyst_report,
      .analyst_stock {
        flex: 1;
        min-height: 200px;
      }
      .analyst_chart {
        height: 240px;
        flex-shrink: 0;
        .analyst_chart_info {
          .text("caption", "normal");
          margin-left: 10px;
          .analyst_chart_info_value {
            margin-left: 5px;
            .text("caption", "up-xh", "medium");
          }
        }
      }
    }
  }
}
</style>
